import React, { useState, useEffect } from 'react';
import PremiumTitleNotification from './PremiumTitleNotification';

const TitleNotificationSystem = () => {
  const [currentNotification, setCurrentNotification] = useState(null);

  useEffect(() => {
    // Listen for title update notifications
    const handleTitleUpdate = (event) => {
      const titleData = event.detail;
      showNotification(titleData);
    };

    window.addEventListener('titleUpdated', handleTitleUpdate);
    return () => window.removeEventListener('titleUpdated', handleTitleUpdate);
  }, []);

  const showNotification = (titleData) => {
    setCurrentNotification(titleData);
  };

  const handleClose = () => {
    setCurrentNotification(null);
  };

  return (
    <PremiumTitleNotification
      titleData={currentNotification}
      onClose={handleClose}
      show={!!currentNotification}
    />
  );
};

export default TitleNotificationSystem;